import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import Text from '../../Common/Form/Text';
import PriceDetails from './PriceDetails';
import { Button } from '../../ui';
import { clean, setHealthValue } from '../../../actions';
import { health } from '../../../operations';

import loader from '../../../assets/common/loader.gif';

const PriceWrapper = styled.div`
  .Price-container {
    display: block;
  }

  .Price-wrapper {
    margin: 0 auto;
    max-width: 420px;
    color: var(--white-color);
  }

  .Price-shadow {
    box-shadow: 0 7px 6px 0 rgba(0, 0, 0, 0.11), 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  }

  .Price-valueContainer {
    position: relative;
    min-height: 130px;
    padding: 8px 16px;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;
    box-shadow: 0 5px 6px 0 rgba(0, 0, 0, 0.24);
    background-image: linear-gradient(
      288deg,
      var(--blue-color),
      var(--light-blue-color2)
    );
  }

  .Price-subvalue {
    font-size: 16px;
  }

  .Price-value {
    font-size: 36px;
    font-weight: bold;
  }

  @media screen and (max-width: 650px) {
    .Price-value {
      font-size: 28px;
    }

    .Price-valueContainer > div:first-child {
      font-size: 14px !important;
    }
  }

  .Price-actionsWrapper {
    margin: 10px 0px;
    text-align: center;
  }

  .Price-errorMessage {
    margin-top: 20px;
    color: firebrick;
  }

  .Price-subtitle {
    background-color: #eee;
    color: var(--blue-color);
    font-weight: 700;
    padding: 1.5em;
    text-align: center;
    font-size: 14px;
  }

  .Price-actions {
    display: flex;
    justify-content: center;
    margin-top: 24px;

    > * + * {
      margin-left: 20px;
    }
  }

  .Price-options {
    margin: 30px auto;
    text-align: center;
    max-width: 420px;
    color: var(--white-color);
  }

  .Price-title {
    margin-bottom: 6px;
    font-size: 16px;
    font-weight: 400;
  }

  .Price-empty {
    font-size: 20px;
    padding-left: 12px;
    padding-right: 12px;
  }

  .Price-marginTop {
    margin-top: 20px !important;
  }

  .Price-marginBottom {
    margin-bottom: 20px !important;
  }
`;

class Price extends Component {
  componentDidMount() {
    const { getQuotation } = this.props;
    getQuotation();
  }

  getPriceContent() {
    const { annualCost, monthlyCost, isLoading, disease, clean } = this.props;

    if (isLoading) {
      return (
        <div>
          <div className="Price-loader">
            <img src={loader} alt="" width="80" height="auto" />
          </div>

          <Text className="Price-marginTop">
            Estamos calculando la mejor opción para vos
          </Text>
        </div>
      );
    }

    if (annualCost === 0) {
      return (
        <div className="Price-options">
          <div className="Price-subvalue">
            <div className="Price-valueContainer">
              <span className="Price-empty">
                No podemos cotizar a partir de los datos ingresados.
              </span>
            </div>
          </div>

          <Button
            className="Price-marginTop"
            onClick={clean}
          >
            Cotizar nuevamente
          </Button>
        </div>
      );
    }

    return (
      <div className="Price-wrapper Price-marginTop">
        <div className="Price-valueContainer">
          <div className="Price-title">
            Asegurá tu SALUD con Seguros SURA por:
          </div>
          <div className="Price-value">
            U$S {annualCost.toString().replace('.', ',')} por año
          </div>
          <div className="Price-subvalue" style={{ marginTop: 6 }}>
            o U$S {monthlyCost.toString().replace('.', ',')} por mes
          </div>
        </div>

        <div className="Price-shadow">
          <div className="Price-subtitle">
            ¿Frente a qué me protege esta cobertura?
          </div>

          <PriceDetails disease={disease} />
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, annualCost, sendQuote, sendMailStatus } = this.props;

    return (
      <PriceWrapper>
        <div className="Price-container">{this.getPriceContent()}</div>

        {!isLoading && annualCost > 0 && (
          <div className="Price-actionsWrapper">
            <div className="Price-actions">
              <Button secondary onClick={() => sendQuote(false)}>
                Lo voy a pensar
              </Button>

              <Button onClick={() => sendQuote(true)}>
                Contratar
              </Button>
            </div>

            {sendMailStatus === false && (
              <Text className="Price-errorMessage">
                No se pudo enviar el email.
              </Text>
            )}
          </div>
        )}
      </PriceWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: state.steps.isInnerLoading,

    capital: state.health.capital,
    disease: state.health.disease,

    monthlyCost: state.health.monthlyCost,
    annualCost: state.health.annualCost,

    sendMailStatus: state.health.sendMailStatus
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clean: () => {
      dispatch(clean());
    },
    getQuotation: () => {
      dispatch(health.getQuotationSalud());
    },
    sendQuote: quoteAccepted => {
      dispatch(setHealthValue('quoteAccepted', quoteAccepted));
      dispatch(health.sendQuoteSalud(quoteAccepted));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Price);
